import { useEffect, useState } from 'react'
import { Button, Popconfirm, Table, Pagination, Flex, Input } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { createCourseCategory, deleteCourseCategory, fetchCourseCategories, updateCourseCategory } from '../../api/learning';

const CourseCategoriesScreen = () => {
    const [tabData, setTabData] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);

    const tabCols = [
        {
            title: 'Index',
            dataIndex: 'id',
            key: 'id',
            render: (text, _, index) => ((pageNum - 1) * pageSize + index + 1)
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text, record, index) => {
                if (record.isEditing) {
                    return <Input
                        allowClear
                        style={{ maxWidth: 200, fontSize: 12 }}
                        value={record.name}
                        placeholder="please input filter"
                        onChange={evt => onInputChange(evt.target.value, index, 'name')}
                    />;
                }
                return text;
            }
        },
        {
            title: 'Weight',
            dataIndex: 'weight',
            key: 'weight',
            render: (text, record, index) => {
                if (record.isEditing) {
                    return <Input
                        style={{ maxWidth: 200, fontSize: 12 }}
                        value={record.weight}
                        placeholder="weight"
                        type="number"
                        onChange={evt => onInputChange(evt.target.value, index, 'weight')}
                    />;
                }
                return text;
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    record.isEditing ?
                        <Button.Group size='small'>
                            <Button type='link' loading={record.isLoading} onClick={() => saveEdit(record)}>Save</Button>
                            <Button type='link' onClick={() => cancelEdit(record)}><label style={{ color: '#afafaf', cursor: 'pointer' }}>Cancel</label></Button>
                        </Button.Group>
                        :
                        <Button.Group size='small'>
                            <Button type='link' onClick={() => editCategory(record)}>Edit</Button>
                            <Popconfirm
                                title="Delete"
                                description="Are you sure to delete this category?"
                                onConfirm={() => deleteCategory(record, [record.id])}
                                okText="Yes"
                                cancelText="No" >
                                <Button danger type='link' loading={record.isLoading}>Delete</Button>
                            </Popconfirm>
                        </Button.Group>
                )
            }
        }
    ];

    useEffect(() => {
        fetchData(pageNum, pageSize);
    }, [])

    const fetchData = (pNum, pSize) => {
        setLoading(true);
        let params = {
            'page.num': pNum,
            'page.size': pSize,
        };
        fetchCourseCategories(params).then(res => {
            if (res.page) {
                setTotal(res.page.total);
            }
            if (res.list) {
                setTabData(res.list.map(item => {
                    return {
                        ...item,
                        isEditing: false,
                        isLoading: false,
                        selectedIds: []
                    };
                }));
            }
        }).finally(() => setLoading(false))
    }

    const pageChange = (page, size) => {
        setPageNum(page);
        setPageSize(size);
        fetchData(page, size);
    }

    const editCategory = (item) => {
        item.isEditing = true;
        setTabData([...tabData]);
    }

    const deleteCategory = (category, ids) => {
        category.isLoading = true;
        setTabData([...tabData]);
        let reqArr = [];
        ids.forEach(item => {
            reqArr.push(deleteCourseCategory(item));
        })

        Promise.all(reqArr).then(res => {
            if (res.some(item => item)) {
                fetchData(pageNum, pageSize);
            }
        })
    }

    const onInputChange = (value, index, key) => {
        tabData[index][key] = value;
        setTabData([...tabData]);
    }

    const saveEdit = (item) => {
        let canSubmit = String(item.name).trim();
        if (!canSubmit) {
            message.warning('Category name can not be empty!');
            return;
        }
        item.isLoading = true;
        setTabData([...tabData]);

        let newItem = { ...item };
        if (newItem.id === '-1') delete newItem['id'];

        let reqArr = [];
        if (newItem.id) {
            reqArr.push(updateCourseCategory(newItem));
        } else {
            reqArr.push(createCourseCategory(newItem));
        }

        Promise.all(reqArr).then(res => {
            fetchData(pageNum, pageSize);
        }).finally(() => {
            setLoading(false);
        });
    }

    const cancelEdit = (item) => {
        item.isEditing = false;
        let newData = [...tabData].filter(cgr => cgr.id !== '-1');
        setTabData(newData);
    }

    const addNewCategory = () => {
        setTabData([
            {
                name: '',
                weight: 0,
                id: '-1',
                isEditing: true,
            }, ...tabData
        ]);
    }

    return (
        <div className='main-wrapper'>
            <div className='top-part cnt-item'>
                <Flex justify='space-between'>
                    <Button type='primary' icon={<PlusOutlined />} onClick={addNewCategory}>Create Article Category</Button>
                </Flex>
            </div>
            <div className='cnt-item'>
                <Table
                    loading={loading}
                    rowKey={(record) => record.id}
                    rowClassName={'table-row'}
                    size='small'
                    dataSource={tabData}
                    columns={tabCols}
                    pagination={false}
                    expandable={{ rowExpandable: (record) => false, showExpandColumn: false }} />
            </div>
            <div className='footer-part cnt-item'>
                <Pagination
                    total={total}
                    showTotal={(total) => `total ${total}`}
                    current={pageNum}
                    pageSize={pageSize}
                    showSizeChanger={true}
                    pageSizeOptions={[10, 20, 30, 50]}
                    onChange={(page, size) => pageChange(page, size)}
                />
            </div>
        </div>
    )
}

export default CourseCategoriesScreen;